import React from 'react'
import { Skeleton, SkeletonButton, SkeletonText, SkeletonAvatar } from '../../../../components/ui/skeleton'

export const TopBarSkeleton: React.FC = () => (
  <header className="h-12 rounded-lg border border-black/10 bg-white flex items-center justify-between px-3 mb-4">
    <div className="flex items-center gap-2">
      {/* Undo/Redo buttons */}
      <div className="flex items-center gap-1">
        <SkeletonButton size="sm" />
        <SkeletonButton size="sm" />
      </div>
      <div className="ml-2">
        {/* Title */}
        <Skeleton height="5" width="48" />
      </div>
    </div>
    <div className="flex items-center gap-2">
      {/* Future actions */}
    </div>
  </header>
)

export const VoiceSelectSkeleton: React.FC = () => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <Skeleton height="4" width="24" />
    </div>
    <div className="h-10 rounded-lg border border-black/10 bg-white p-2">
      <Skeleton height="4" width="32" />
    </div>
  </div>
)

export const SidebarSkeleton: React.FC = () => (
  <aside className="min-h-0 h-full overflow-auto space-y-5 rounded-xl border border-black/10 bg-gradient-to-b from-white to-black/[0.02] p-5">
    <div className="h-full flex flex-col">
      <div className="space-y-5">
        <VoiceSelectSkeleton />
        <div className="h-px bg-black/10" />
        <VoiceSelectSkeleton />
      </div>
      <div className="flex-1" />
    </div>
  </aside>
)

export const EditorHeaderSkeleton: React.FC = () => (
  <div className="h-14 border-b border-black/5 px-5 flex items-center justify-between bg-gradient-to-r from-white to-black/[0.02]">
    <div className="flex items-center gap-2">
      <SkeletonAvatar size="sm" />
      <Skeleton height="4" width="16" />
    </div>
  </div>
)

export const PodcastLineItemSkeleton: React.FC = () => (
  <div className="bg-white rounded-xl border border-black/5 p-6">
    {/* Header with speaker badge and actions */}
    <div className="flex items-center justify-between gap-3 mb-3">
      <div className="flex items-center gap-2 min-w-0">
        <Skeleton height="6" width="16" />
        <Skeleton height="3" width="8" />
      </div>
      <div className="flex items-center gap-2">
        <SkeletonButton size="sm" />
        <SkeletonButton size="sm" />
      </div>
    </div>

    {/* Text content */}
    <div className="space-y-2">
      <SkeletonText lines={3} />
    </div>
  </div>
)

export const PodcastLinesEditorSkeleton: React.FC = () => (
  <div className="p-8 space-y-8">
    {/* Lines */}
    <div className="space-y-6 max-w-4xl mx-auto">
      {Array.from({ length: 4 }, (_, i) => (
        <PodcastLineItemSkeleton key={i} />
      ))}
    </div>

    {/* Sticky footer CTA */}
    <div className="sticky bottom-0 inset-x-0 border-t border-black/10 bg-white">
      <div className="max-w-4xl mx-auto px-8 py-4 flex items-center justify-between gap-3">
        <Skeleton height="4" width="32" className="hidden sm:block" />
        <SkeletonButton size="md" />
      </div>
    </div>
  </div>
)

export const CompletePodcastEditorSkeleton: React.FC = () => (
  <div className="p-4">
    <TopBarSkeleton />
    <div className="grid grid-cols-1 lg:grid-cols-[25%_1fr] gap-4 h-[calc(100vh-4rem)]">
      <SidebarSkeleton />
      <section className="rounded-xl border border-black/10 bg-white h-full overflow-auto">
        <EditorHeaderSkeleton />
        <PodcastLinesEditorSkeleton />
      </section>
    </div>
  </div>
)
